module.exports = __webpack_public_path__ + "img/dummy1.488c491.jpg";